import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CardHeader from './CardHeader';
import CardTagLine from './CardTagLine';
import DateTimeIntervalDisplay from './DateTimeIntervalDisplay';
import AvailabilityPill from './AvailabilityPill';

export default class EventCard extends Component {
  static propTypes = {
    type: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    summary: PropTypes.string,
    url: PropTypes.string.isRequired,
    start_date: PropTypes.string.isRequired,
    end_date: PropTypes.string.isRequired,
    author: PropTypes.any.isRequired,
    collapsed: PropTypes.bool,
    showDetails: PropTypes.bool,
    isScarce: PropTypes.bool,
    isHosting: PropTypes.bool.isRequired,
    isAttending: PropTypes.bool,
    isPending: PropTypes.bool,
    isBooked: PropTypes.bool.isRequired,
    isPastSignup: PropTypes.bool.isRequired,
    availableSlots: PropTypes.number,
    location: PropTypes.string.isRequired,
    useTimezone: PropTypes.string,
    image: PropTypes.string,
    tags: PropTypes.array,
    inModal: PropTypes.bool,
    maxTags: PropTypes.number,
    virtualProvider: PropTypes.any,
  };

  static defaultProps = {
    useTimezone: moment.tz.guess(),
    description: null,
    inModal: false,
    summary: null,
    image: null,
    tags: [],
    maxTags: 4,
    collapsed: true,
    availableSlots: null,
    isAttending: false,
    isPending: false,
    isScarce: false,
    showDetails: true,
    virtualProvider: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      collapsed: this.props.collapsed,
    };
  }

  handleCollapseToogle = () => {
    this.setState({ collapsed: !this.state.collapsed });
  };

  renderDropdownTrigger() {
    return (
      <span className="u-text-grey">
        <i className="Icon-more u-flex u-color-grey u-items-center" />
      </span>
    );
  }

  render() {
    const startDate = moment(this.props.start_date);
    let buttonText = null;

    if (this.props.isAttending || this.props.isPending) {
      buttonText = 'Manage RSVP';
    } else if (
      !this.props.isHosting &&
      !this.props.isAttending &&
      !this.props.isPending &&
      !this.props.isBooked &&
      !this.props.isPastSignup
    ) {
      buttonText = 'RSVP';
    } else {
      buttonText = 'View details';
    }

    return (
      <div className="Card-v2" data-card-type={this.props.type} data-card-title={this.props.title}>
        {/* Card header */}
        <div className="Card-v2-section Card-v2-header u-bg-grey-lightest u-border-b u-border-grey-lighter u-rounded-t">
          <div className="u-flex u-flex-row">
            <div className="u-flex-1">
              <CardHeader
                author={this.props.author}
                useTimezone={this.props.useTimezone}
                url={this.props.url}
                title={this.props.title}
                label={this.props.label}
                isEvent
              />
            </div>
            <div className="u-flex-none u-ml-4">
              <div className="AgendaEventDate">
                <span className="u-text-xl u-leading-none u-align-bottom">
                  {startDate.format('DD')}
                </span>
                <br />
                <span className="u-uppercase u-text-xs u-align-top">{startDate.format('MMM')}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Card image */}
        {this.props.image && (
          <div className="u-p-6 u-pb-0">
            <img className="u-rounded-lg u-w-full" alt={this.props.title} src={this.props.image} />
          </div>
        )}

        {/* Card description */}
        <div className="Card-v2-section Card-v2-description Readability u-u-mb-4 u-p-6">
          <div dangerouslySetInnerHTML={{ __html: this.props.description }} />
        </div>

        {/* Card tags */}
        {this.props.showDetails && (
          <CardTagLine
            className="Card-v2-section u-mb-4"
            seeMoreURL={this.props.url}
            tags={this.props.tags}
            maxTags={this.props.maxTags}
            keyIdentifier={this.props.title}
          />
        )}

        {/* Event details */}
        {this.props.showDetails && (
          <div className="Card-v2-section Card-v2-detail u-flex u-border-t u-border-grey-lighter">
            <div className="u-flex-grow">
              <div className="Card-detailInfo-date u-m-0 u-block u-text-md">
                <DateTimeIntervalDisplay
                  useTimezone={this.props.useTimezone}
                  start_date={this.props.start_date}
                  end_date={this.props.end_date}
                  full_day_name
                />
              </div>
              <div className="Card-detailInfo-location u-flex u-items-center u-text-md">
                {this.props.location}
                {this.props.virtualProvider && (
                  <>
                    <img className="u-w-5 u-mx-2" alt={this.props.virtualProvider.name} src={this.props.virtualProvider.iconPath} />
                    { this.props.virtualProvider.name }
                  </>
                )}
              </div>
            </div>
            <div className="u-flex-shrink u-whitespace-no-wrap">
              <AvailabilityPill event={this.props} />
              <a className="Button Button--primary" href={this.props.url}>
                {buttonText}
                <i className="Icon Icon-arrow-forward u-ml-1 u-mr-0" />
              </a>
            </div>
          </div>
        )}
      </div>
    );
  }
}
